import React from "react";
import { Image, Stack, Carousel } from "react-bootstrap";
import { map } from "lodash";
import './B2BAgents1.css';

export const B2BAgents1 = ({ data, heading, desc }) => {
  return (
    <Stack className="b2bAgents1 standard-padding">
      <p className="subheading">{heading}</p>
      <h1 className="heading b2bagentsec1 align-text-mobile">{desc}</h1>

      {/* Desktop / Tablet Grid View (Visible on md and up) */}
      <div className="b2bAgents1-wrap d-none d-md-flex">
        {map(data, (d) => (
          <ContactDetails key={d.id} data={d} />
        ))}
      </div>

      {/* Mobile Slider View (Visible on screens below md) */}
      <div className="b2bAgents1-mobile-slider d-block d-md-none w-100">
        <Carousel controls={false} indicators={true} interval={4000}>
          {map(data, (d) => (
            <Carousel.Item key={d.id}>
              <div className="mobile-card-container">
                <ContactDetails data={d} />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </Stack>
  );
};

const ContactDetails = ({ data }) => {
  return (
    <Stack className="b2bAgents1-card">
      <p className="b2bAgents1-image">
        <Image src={data.img} alt="image" className="b2bAgents1-IMAGE" />
      </p>
      <Stack className="b2bAgents1-content">
        <h4 className="b2bAgents1-title">{data.title}</h4>
        <p className="b2bAgents1-text">{data.desc}</p>
      </Stack>
    </Stack>
  );
};